import { useEffect, useRef } from 'react';
import { purgeUserScopedCaches } from '../lib/userScopedCache';

// Purge the previous user's account-scoped caches when the active user id changes
// (a different user signing in on a shared browser without an explicit sign-out,
// or a sign-out). Scoped to the PREVIOUS user's keys so the newly signed-in
// user's freshly written cache is never nuked (WP-19).
export function useIdentityChangePurge(session) {
  const userId = session?.user?.id || null;
  const prevUserIdRef = useRef(userId);

  useEffect(() => {
    const prev = prevUserIdRef.current;
    if (prev && prev !== userId) {
      purgeUserScopedCaches(prev);
    }
    prevUserIdRef.current = userId;
  }, [userId]);
}
